import { APPLICATION_TITLE } from '@/Module/Core/Constant';
import { prepareGradeTitle } from '@/Module/Lesson/Helper';

export const preparePageTitleCategory = (
  gradePageTitle: string,
  fundamental: string,
  title: string,
  grade: string,
  pageTitle: string,
) => {
  if (gradePageTitle?.includes('ابتدایی')) {
    return `${pageTitle} ابتدایی | ${APPLICATION_TITLE}`;
  }
  if (gradePageTitle?.includes('تیزهوشان')) {
    return ` ویدیوهای آموزشی تیزهوشان ${pageTitle.replace('ویدیوهای آموزشی', '')}  | ${APPLICATION_TITLE}`;
  }
  if (gradePageTitle?.includes('کنکور')) {
    return ` ویدیوهای آموزشی کنکور ${title} ${prepareGradeTitle({ title: grade })} | ${APPLICATION_TITLE}`;
  }
  if (gradePageTitle?.includes('امتحان نهایی')) {
    return ` ویدیوهای آموزشی حل نمونه سوالات ${fundamental} ${title} ${prepareGradeTitle({ title: grade })}`;
  }
  if (gradePageTitle?.includes('امتحانات')) {
    const isMiddleSchool =
      gradePageTitle.includes('هفتم') || gradePageTitle.includes('هشتم') || gradePageTitle.includes('نهم');

    const gradeLabel = isMiddleSchool ? 'متوسطه' : 'ابتدایی';
    return ` دانلود نمونه سوالات امتحانی${pageTitle.split('ویدیوهای آموزشی')[1]} ${gradeLabel} | ${APPLICATION_TITLE}`;
  }
  return `${pageTitle} | ${APPLICATION_TITLE}`;
};
